import {ClientStore} from "../../stores/clientStore";
import {WidgetApiService} from "./widgetApiService";

export interface UwRulesService {
    sendForApproval: (id: string) => Promise<any>;
}

export class DefaultUwRulesService implements UwRulesService {
    constructor(private clientStore: ClientStore, private widgetSrvc: WidgetApiService) {}

    public async sendForApproval(id: string): Promise<any> {
        return this.clientStore.uwRulesRequestStatus.handleRequest(() => this.widgetSrvc.sendForApproval(id));
    }
}